import { DecimalScale } from '@globaleris/ui.library';
import moment from 'moment';
import { EnumTipoOperacion } from '../../../api';
import { formatLocaleNumber } from '../../../helpers/numberHelper';
import { NO_DATA } from '../../../model';
import {
  BalanceModel,
  BalanceOperationCalculationModel,
  BalanceResponsiveModel
} from '../balances.model';
import { calculateBalance } from '../balances.services';

export const calculateResponsiveBalance = (
  balance: BalanceModel,
  operations: Array<BalanceOperationCalculationModel>,
  date: Date
): BalanceResponsiveModel => {
  let responsiveBalance: BalanceResponsiveModel = {
    stock: NO_DATA,
    previousStock: NO_DATA,
    unbalance: NO_DATA,
    followingStock: NO_DATA
  };
  const tab = balance.id;
  // eslint-disable-next-line eqeqeq
  if (tab != 1) {
    balance = calculateBalance(balance, operations, moment(date).add(-1, 'days').toDate(), date);
  } else {
    balance = calculateBalance(balance, operations, date, moment(date).add(1, 'days').toDate());
  }

  if (balance && balance.data && balance.data.length === 2) {
    switch (tab) {
      case 1:
        const demandaMin = balance.columnsConfiguration?.find(
          x => x.operationType === EnumTipoOperacion.DemandaConvencional
        );
        const demandaMay = balance.columnsConfiguration?.find(
          x => x.operationType === EnumTipoOperacion.DemandaLLDD
        );

        if (demandaMin && demandaMay) {
          responsiveBalance.followingStock = formatLocaleNumber(
            balance.data[1][
              balance.columnsConfiguration?.find(
                x => x.operationType === EnumTipoOperacion.DemandaConvencional
              )?.id!
            ] +
              balance.data[1][
                balance.columnsConfiguration?.find(
                  x => x.operationType === EnumTipoOperacion.DemandaLLDD
                )?.id!
              ],
            DecimalScale.ENERGY
          );

          responsiveBalance.stock = formatLocaleNumber(
            balance.data[0][
              balance.columnsConfiguration?.find(
                x => x.operationType === EnumTipoOperacion.DemandaConvencional
              )?.id!
            ] +
              balance.data[0][
                balance.columnsConfiguration?.find(
                  x => x.operationType === EnumTipoOperacion.DemandaLLDD
                )?.id!
              ],
            DecimalScale.ENERGY
          );

          const unbalanceColumn = balance.columnsConfiguration?.find(
            x => x.operationType === EnumTipoOperacion.Desbalance
          );
          if (unbalanceColumn) {
            responsiveBalance.unbalance = formatLocaleNumber(
              balance.data[0][unbalanceColumn.id],
              DecimalScale.ENERGY
            );
          }
        }

        break;
      case 2:
      case 3:
        const stockColumn = balance.columnsConfiguration?.find(
          x => x.operationType === EnumTipoOperacion.Existencias
        );

        if (stockColumn) {
          responsiveBalance.previousStock = formatLocaleNumber(
            balance.data[0][stockColumn.id],
            DecimalScale.ENERGY
          );

          responsiveBalance.stock = formatLocaleNumber(
            balance.data[1][
              balance.columnsConfiguration?.find(
                x => x.operationType === EnumTipoOperacion.Existencias
              )?.id!
            ],
            DecimalScale.ENERGY
          );
          const unbalanceColumn = balance.columnsConfiguration?.find(
            x => x.operationType === EnumTipoOperacion.Desbalance
          );
          if (unbalanceColumn) {
            responsiveBalance.unbalance = formatLocaleNumber(
              balance.data[1][unbalanceColumn.id],
              DecimalScale.ENERGY
            );
          }
        }

        break;

      default:
    }
  }
  return responsiveBalance;
};

// export const calculateResponsiveBalance = (
//   balance: BalanceModel,
//   operations: Array<BalanceOperationCalculationModel>,
//   date: Date,
//   tab?: Number
// ): BalanceResponsiveModel => {
//   let responsiveBalance: BalanceResponsiveModel = {
//     stock: NO_DATA,
//     previousStock: NO_DATA,
//     unbalance: NO_DATA,
//     followingStock: NO_DATA
//   };

//   // balance = calculateBalance(balance, operations, moment(date).add(-1, 'days').toDate(), date);
//   // balance = calculateBalance(balance, operations, date, moment(date).add(1, 'days').toDate());
//   console.log('TAB ACTIVO ' + tab);
//   tab !== 0
//     ? (balance = calculateBalance(balance, operations, date, moment(date).add(1, 'days').toDate()))
//     : (balance = calculateBalance(
//         balance,
//         operations,
//         moment(date).add(-1, 'days').toDate(),
//         date
//       ));

//   if (balance && balance.data && balance.data.length === 2) {
//     if (tab === 0) {
//       console.log('ENTRA CASE 0');
//       const demandaMin = balance.columnsConfiguration?.find(
//         x => x.operationType === EnumTipoOperacion.DemandaConvencional
//       );
//       const demandaMay = balance.columnsConfiguration?.find(
//         x => x.operationType === EnumTipoOperacion.DemandaLLDD
//       );

//       if (demandaMin && demandaMay) {
//         responsiveBalance.followingStock = formatLocaleNumber(
//           balance.data[1][demandaMin.id] + balance.data[1][demandaMay.id],
//           DecimalScale.ENERGY
//         );

//         responsiveBalance.stock = formatLocaleNumber(
//           balance.data[0][
//             balance.columnsConfiguration?.find(
//               x => x.operationType === EnumTipoOperacion.DemandaConvencional
//             )?.id!
//           ] +
//             balance.data[0][
//               balance.columnsConfiguration?.find(
//                 x => x.operationType === EnumTipoOperacion.DemandaLLDD
//               )?.id!
//             ],
//           DecimalScale.ENERGY
//         );
//       } else {
//         console.log('ENTRA CASE 1 Y 2');

//         const stockColumn = balance.columnsConfiguration?.find(
//           x => x.operationType === EnumTipoOperacion.Existencias
//         );

//         if (stockColumn) {
//           responsiveBalance.previousStock = formatLocaleNumber(
//             balance.data[0][stockColumn.id],
//             DecimalScale.ENERGY
//           );

//           responsiveBalance.stock = formatLocaleNumber(
//             balance.data[1][
//               balance.columnsConfiguration?.find(
//                 x => x.operationType === EnumTipoOperacion.Existencias
//               )?.id!
//             ],
//             DecimalScale.ENERGY
//           );
//         }
//       }
//     }
//     const unbalanceColumn = balance.columnsConfiguration?.find(
//       x => x.operationType === EnumTipoOperacion.Desbalance
//     );
//     if (unbalanceColumn) {
//       responsiveBalance.unbalance = formatLocaleNumber(
//         balance.data[1][unbalanceColumn.id],
//         DecimalScale.ENERGY
//       );
//     }
//   }
//   return responsiveBalance;
// };
